// Single source of truth for the frontend build version.
// Compared against GET /api/app/version to detect stale PWA/service-worker
// caches (see the version-drift self-healer in AdminLogin & AdminDashboard).
// Bump this on every frontend change.
export const APP_BUILD_VERSION = "2026.07.18-80";
